import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';
import styled from 'styled-components';

export const ErrorCont = styled.div`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;
  background-color: #fff;

  ${mixin.flex({ direction: 'column' })}
  text-align: center;
  height: 100vh;

  .title {
    margin-top: 20px;
    font-size: 24px;
    font-weight: 600;
    line-height: 120%;
    color: #000;
  }

  .detail {
    margin-top: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    color: #777;
  }

  .btn-link {
    flex: none;
    margin-top: 20px;
    border: 1px solid #000;
    width: 170px;
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    line-height: 130%;
    color: #000;
    background-color: #fff;
    ${mixin.flex({ direction: 'row-reverse' })};

    svg {
      width: 7px;
      height: 10px;
      margin-left: 7px;
    }
  }

  .btn-logo {
    margin-top: 140px;
  }

  .info {
    ${mixin.flex({ wrap: 'wrap', justify: 'flex-start', align: 'flex-start' })}
    background-color: #f9f9f9;
    padding: 14px 20px;
    color: #555;
    text-align: left;
    margin: 12px 47px 0 47px;
    row-gap: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
    width: 280px;

    dt {
      width: 50px;
    }

    dd {
      width: 182px;
      margin-left: 8px;
    }
  }

  &.type-500,
  &.type-network,
  &.type-service-check,
  &.type-filter {
    .btn-link {
      ${mixin.flex({ direction: 'row' })};

      svg {
        width: 14px;
        height: 14px;
        margin-left: 0;

        + span {
          margin-left: 5px;
        }
      }
    }
  }

  &.type-filter {
    .title {
      font-size: 14px;
      line-height: 130%;
      font-weight: 400;
      margin: 0;
    }
  }

  // ios
  @supports (-webkit-touch-callout: none) {
    height: -webkit-fill-available;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .title {
      margin-top: ${mixin.pxToVw('20')};
      font-size: ${mixin.pxToVw('24')};
    }

    .detail {
      margin-top: ${mixin.pxToVw('12')};
      font-size: ${mixin.pxToVw('14')};
    }

    .btn-link {
      margin-top: ${mixin.pxToVw('20')};
      width: ${mixin.pxToVw('170')};
      height: ${mixin.pxToVw('40')};
      font-size: ${mixin.pxToVw('14')};

      svg {
        width: ${mixin.pxToVw('7')};
        height: ${mixin.pxToVw('10')};
        margin-left: ${mixin.pxToVw('7')};
      }
    }

    .btn-logo {
      margin-top: ${mixin.pxToVw('140')};
    }

    .info {
      padding: ${mixin.pxToVw('14 20')};
      margin: ${mixin.pxToVw('12 47 0 47')};
      row-gap: ${mixin.pxToVw('12')};
      font-size: ${mixin.pxToVw('14')};
      width: ${mixin.pxToVw('280')};

      dt {
        width: ${mixin.pxToVw('50')};
      }

      dd {
        width: ${mixin.pxToVw('182')};
        margin-left: ${mixin.pxToVw('8')};
      }
    }

    &.type-500,
    &.type-network,
    &.type-service-check,
    &.type-filter {
      .btn-link {
        svg {
          width: ${mixin.pxToVw('14')};
          height: ${mixin.pxToVw('14')};

          + span {
            margin-left: ${mixin.pxToVw('5')};
          }
        }
      }
    }

    &.type-filter {
      .title {
        font-size: ${mixin.pxToVw('14')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    height: auto;
    padding-top: 180px;

    .title {
      margin-top: 30px;
      font-size: 26px;
      line-height: 130%;
    }

    .detail {
      margin-top: 20px;
      font-size: 16px;
      line-height: 150%;
    }

    .btn-link {
      margin-top: 30px;
      width: 180px;
      height: 50px;
      font-size: 15px;

      svg {
        width: 8px;
        height: 12px;
        margin-left: 8px;
      }
    }

    .btn-logo {
      margin-top: 80px;

      svg {
        width: 119px;
        height: 17px;
      }
    }

    .info {
      margin: 30px 0 0 0;
      font-size: 16px;
      width: 300px;

      dt {
        width: 56px;
      }

      dd {
        width: 192px;
        margin-left: 10px;
      }
    }

    &.type-500,
    &.type-network,
    &.type-service-check {
      .btn-link {
        svg {
          width: 16px;
          height: 16px;

          + span {
            margin-left: 7px;
          }
        }
      }
    }

    &.type-filter {
      .title {
        color: #777;
      }

      .btn-link {
        width: 170px;
        height: 40px;
        margin-top: 20px;

        svg {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
`;
